import { render, staticRenderFns } from "./profileAseg.vue?vue&type=template&id=5c810be6&scoped=true"
import script from "./profileAseg.vue?vue&type=script&lang=js"
export * from "./profileAseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c810be6",
  null
  
)

export default component.exports